module.exports = "/_next/static/images/elektrika-e0bb6be8aa9e43219e564b24cb0c5790.svg";